<template>
  <BasicLayout>
    <template #wrapper>
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>宝箱概率配置修改</span>
        </div>
        <el-table
          :data="formData"
          border
          style="width: 100%"
        >
          <el-table-column
            prop="id"
            label="类型"
          >
            <template slot-scope="{row}">
              <el-select v-model.number="row.type" placeholder="请选择">
                <el-option
                  v-for="item in cardType"
                  :key="item.id"
                  :label="item.title"
                  :value="item.id"
                />
              </el-select>
            </template>
          </el-table-column>
          <el-table-column
            v-for="(item, index) in [0,1,2,3,4]"
            :key="index"
            :label="probability[index].title"
          >
            <template slot-scope="{row}">
              <el-input v-model.number="row.star_pro[item].v" :placeholder="probability[index].title" />
            </template>
          </el-table-column>
          <el-table-column
            prop="maxGoldCard"
            label="金卡数量(-1,不设限制)"
          >
            <template slot-scope="scope">
              <el-input v-model.number="scope.row.maxGoldCard" placeholder="金卡数量(-1,不设限制)" />
            </template>
          </el-table-column>
        </el-table>
        <el-button v-permisaction="['config:cardPro:save']" size="mini" type="primary" @click="onSubmit()">保存</el-button>
      </el-card>
    </template>
  </BasicLayout>
</template>

<script>
import { getList, updateCardPro } from '@/api/config/card-pro'
export default {
  name: 'CardPro',
  data() {
    return {
      queryParams: {
        pageIndex: 1,
        pageSize: 10
      },
      cardType: [
        {
          'id': 1,
          'title': '木质宝箱'
        },
        {
          'id': 2,
          'title': '白银宝箱'
        },
        {
          'id': 3,
          'title': '黄金宝箱'
        },
        {
          'id': 4,
          'title': '魔法宝箱'
        },
        {
          'id': 5,
          'title': '偷出卡片'
        },
        {
          'id': 6,
          'title': '完成任务'
        }, {
          'id': 10,
          'title': '绿宝箱'
        },
        {
          'id': 11,
          'title': '蓝宝箱'
        },
        {
          'id': 12,
          'title': '红宝箱'
        },
        {
          'id': 19,
          'title': '小丑宝箱'
        },
        {
          'id': 20,
          'title': '狐狸宝箱'
        },
        {
          'id': 21,
          'title': '钻石宝箱'
        },
        {
          'id': 29,
          'title': '圣诞宝箱'
        },
        {
          'id': 30,
          'title': '麋鹿宝箱'
        }
      ],
      probability: [
        { 'title': '一星概率' },
        { 'title': '二星概率' },
        { 'title': '三星概率' },
        { 'title': '四星概率' },
        { 'title': '五星概率' }
      ],
      formData: [
        {
          'type': 1,
          'star_pro': [
            { 'star': 1, 'v': '65' },
            { 'star': 2, 'v': '65' },
            { 'star': 3, 'v': '65' },
            { 'star': 4, 'v': '65' }
          ],
          'maxGoldCard': -1
        }
      ]
    }
  },
  created() {
    this.getTables()
  },
  methods: {
    onSubmit() {
      const data = JSON.stringify(this.formData)
      console.log(data)
      updateCardPro({ data: data }).then(res => {
        if (res.code === 200) {
          this.msgSuccess(res.msg)
          this.getTables()
        } else {
          this.msgError(res.msg)
        }
      })
    },
    getTables() {
      getList().then(res => {
        this.formData = res.data
      })
    }
  }
}
</script>

<style scoped>
</style>
